import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useNavigate, useParams } from "react-router-dom";
import { categories } from "../data/category";
import ListViewer from "../components/ListViewer";
import Products from "../components/Products";
import { FaEye, FaRegHeart, FaRegStar, FaStar } from "react-icons/fa";
import { RiShoppingCartLine } from "react-icons/ri";
import { FaCodeCompare } from "react-icons/fa6";
import { products } from "../data/products";
import { getALLCategory, getAllProducts } from "../apis/config";
import ProductCard from "../components/ProductCard";
import ComingSoon from "./ComingSoon";
// import image from "../../public/assets/1.jpg"

const TypePage = () => {
  const { category,subCategory,type } = useParams();
  const [length, setLength] = useState(false);
  const navigate = useNavigate()
   const [categorys,setCategorys] = useState([])
   const [products,setProducts] = useState([])
   const [sel,setSel] = useState('All')
   useEffect(()=>{
      getALLCategory().then(res=>setCategorys(res.data)).catch(err=>console.log(err))
      getAllProducts().then(res=>setProducts(res.data)).catch(err=>console.log(err))
    },[])
  const subCateId= categorys.find((cat) => cat.name === category)?.subcategories.find(s=>s.name===subCategory)?._id
  const subcat = categorys.find((cat) => cat.name === category)?.subcategories.find(s=>s.name===subCategory)?.types;
  const typeId = subcat?.find((cat) => cat.name === type)?._id
  const styles = subcat?.find((cat) => cat.name === type)?.styles
  let filterProducts = []
  if(sel==='All'){
    filterProducts = products.filter(pro=>pro.type === typeId)
  }else{
    filterProducts = products.filter(pro=>pro.style === sel)
  }
  return (
    <>
      {/* <Header/> */}
      <div className=" px-5 md:px-10">
        <h6 className="  text-gray-400 text-[10px] mt-2 capitalize text-center">
          <span className=" hover:text-black cursor-pointer" onClick={()=>navigate('/')}>Home</span> {">"} 
          <span className=" hover:text-black cursor-pointer" onClick={()=>navigate(`/category/${category}`)}>{category}</span> {">"} 
          <span className=" hover:text-black cursor-pointer" onClick={()=>navigate(`/category/${category}/${subCategory}`)}>{subCategory}</span> {">"}
          <span className=" text-gray-700 hover:text-black cursor-pointer" onClick={()=>navigate(`/category/${category}/${subCategory}/${type}`)}>{type}</span>
        </h6>
        <h3 className=" text-primary font-semibold capitalize pt-5 text-center text-xl">
          {type}
        </h3>
        {/* <div className="w-full mb-5 text-center text-[12px] flex justify-center items-center">
            <p className=" w-[800px]"> 
                Buying a sofa couch from Pepperfry offers many advantages. With a wide range of stylish, affordable options in various materials and designs, you're sure to find one that fits your needs.  shopping online at India’s top furniture store...
            </p>
        </div> */}
        {styles?.length > 0 && <div className=" flex gap-2 flex-wrap justify-center items-center">
        <div
              className=" bg-gray-100 flex flex-col justify-center items-center p-2 my-5 gap-2"
            >
              <div className=" w-24 h-24">
                <img
                  src="/assets/all.webp"
                  alt={"product"}
                  className=" w-full h-full object-cover"
                />
              </div>
              <h4 className=" text-[12px] text-center capitalize cursor-pointer" onClick={()=>setSel('All')}>
                All
              </h4>
            </div>
          {styles?.map((sub, index) => (
            <div
              key={index}
              className=" bg-gray-100 flex flex-col justify-center items-center p-2 gap-2"
            >
              <div className=" w-24 h-24">
                <img
                  src={sub.image}
                  alt={sub.name}
                  className=" w-full h-full object-cover"
                />
              </div>
              <h4 className=" text-[12px] text-center capitalize cursor-pointer" onClick={()=>setSel(sub._id)}>
                {sub.name}
              </h4>
            </div>
          ))}
        </div>}
        {/* <div
          className=" text-red-600 text-[12px] text-center py-5 cursor-pointer"
          onClick={() => setLength(!length)}
        >
          {length
            ? "Show less ->"
            : `Show all Categories (${subcat.length}) ->`}
        </div> */}
         {filterProducts.length > 0  ?<div className=" grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 justify-between py-5">
                {filterProducts.map((data, index) => (
                  <ProductCard key={index} data={data}/>
                ))}
              </div>:<ComingSoon/>}

      </div>
      {/* <Footer/> */}
    </>
  );
};

export default TypePage;
